import { useQuery } from '@tanstack/react-query';

import type { Integration } from '~/interfaces/integration';

export const integrationsKeys = {
  all: ['integrations'] as const,
  bySubscriber: (subscriberId: string) => ['integrations', subscriberId] as const,
};

const fetchIntegrations = async (): Promise<Integration[]> => {
  const response = await fetch('/integrations');
  if (!response.ok) throw new Error('Failed to fetch integrations');
  return response.json();
};

interface ReturnProps {
  isLoading: boolean;
  integrations: Integration[];
  refetch: () => void;
}

const useIntegrations = (subscriberId: string, enabled: boolean): ReturnProps => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: integrationsKeys.bySubscriber(subscriberId),
    queryFn: fetchIntegrations,
    enabled: enabled && !!subscriberId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading,
    integrations: data ?? [],
    refetch,
  };
};

export default useIntegrations;
